export default __webpack_public_path__ + "static/media/ptm_quiz_bg.22363223.png";